import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from 'antd'
import { changeLine } from './utils'

const { Text } = Typography

// The before and after of each field a change touched, as short lines. Long values truncate with a
// tooltip (the browser's title) rather than breaking the table's layout.
const FieldChanges = ({ changes }) => (
  <div>
    {(changes || []).map(change => (
      <div key={change.name}>
        <Text ellipsis style={{ maxWidth: 360 }} title={changeLine(change)}>
          {changeLine(change)}
        </Text>
      </div>
    ))}
  </div>
)

FieldChanges.propTypes = {
  changes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      before: PropTypes.string,
      after: PropTypes.string
    })
  )
}

export default FieldChanges
